import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'
import { CatchwordProps } from '@widgets/Teaser/playlist/types'
import { desktopCSS } from '@measures/responsive'

const StyledCatchword = styled.div`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: {
        grey: { grey_10 },
      },
    },
  }) => {
    return css`
      font-size: 16px;
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      line-height: 1.1;
      color: ${grey_10};

      > strong {
        color: ${grey_10};
        font-weight: 500;
      }

      > p {
        margin: 0;
      }

      ${ellipsis('100%', 2)};

      margin-bottom: 3px;

      ${desktopCSS(css`
        display: none;
      `)}
    `
  }}
`

const Catchword: FunctionComponent<CatchwordProps> = ({ children }) => {
  return (
    <StyledCatchword
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  )
}

export default Catchword
